export default class ProgressBarLoader {
    constructor(container) {
        this.loaderContainer = '.loader';
        this.container = $(container);
    }

    getLoader() {
        if (!this.container.find(this.loaderContainer).length) {
            this.appendLoader();
        }

        return this.container.find(this.loaderContainer);
    }

    appendLoader() {
        $('<div/>')
            .addClass('mt-5 w-full sm:w-pb')
            .addClass(this.loaderContainer.substring(1))
            .append(
                $('<div/>')
                    .addClass('overflow-hidden h-2 rounded bg-gray-200 relative')
                    .append(
                        $('<div/>')
                            .addClass('bg-indigo-600 rounded absolute top-0 bottom-0 w-1/3 progress')
                    )
            )
            .appendTo(this.container);
    }

    show() {
        this.getLoader().removeClass('hidden');
    }
    hide() {
        this.getLoader().addClass('hidden');
    }
}
